import {useState, useRef, useEffect, useCallback, useContext} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, CardText, Form, Label, Input, Button } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import AuthContext from "../../context/AuthProvider";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';

const AddSlider = () => {
  const {auth} = useAuth();

  const axiosPrivate = useAxiosPrivate(auth.refreshToken);
  const navigate = useNavigate();
  const location = useLocation();

   // ** States
   let initialState = {
    sliderTitle: '',
    sliderDesc: '',
    sequence: ''
  };
   const [sliderInfo, setSliderInfo] = useState(initialState)
  //  const [productImg, setProductImg] = useState("");
  const fileInputRef = useRef();
  const [productImg, setProductImg] = useState(null)
  const [mykey, setMyKey] = useState('')

  // const handleCreateBase64 = useCallback(async (e) => {
  //     const file = e.target.files[0];
  //     const base64Img = await convertToBase64(file);
  //     setProductImg(base64Img)
  //     e.target.value = ""
  // }, [])

  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image")
      }else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
      }
      fileReader.onerror = error => {
          reject(error)
      }
    })
  }
  const addImage = async (e) => {
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    // setProductImg(base64Img)
    fileInputRef.current.value = base64Img;
    setProductImg(e.target.files[0]);
  };

  // useEffect(() => {
  //   if (fileInputRef) fileInputRef.current.value = null;
  // }, [productImg]);



    const handleChange = (event) => {
        const { value, name } = event.target
        setSliderInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

   
    const handleSaveClick = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('sliderTitle', sliderInfo.sliderTitle);
        formData.append('sliderDesc', sliderInfo.sliderDesc);
        formData.append('sequence', sliderInfo.sequence);
        formData.append('productImg', productImg);

        // let isMounted = true;
        const controller = new AbortController();
    
        try {
            const res = await axiosPrivate.post(`${process.env.REACT_APP_API_BASE_URL}/sliders/add-slider`, formData, {
              signal: controller.signal
          })

            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            setSliderInfo(initialState)
            setProductImg("");
            let st = Math.random();
            setMyKey(st)
            fileInputRef.current.value = ""

        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      setSliderInfo(initialState)
      setProductImg(null);
      fileInputRef.current.value = '';
      let st = Math.random();
      setMyKey(st)
    }


  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Add Slider</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Slider Title <span className='text-danger'>*</span>
              </Label>
              <Input
                id='title'
                type='text'
                className='me-1'
                name='sliderTitle'
                minLength={20}
                maxLength={90}
                required={true}
                value={sliderInfo.sliderTitle}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Slider Description <span className='text-danger'>*</span>
              </Label>
              <Input
                id='sliderDesc'
                type='textarea'
                className='me-1'
                name='sliderDesc'
                minLength={60}
                maxLength={150}
                required={true}
                value={sliderInfo.sliderDesc}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Sequence No <span className='text-danger'>*</span>
              </Label>
              <Input
                id='sequence'
                type='number'
                className='me-1'
                name='sequence'
                min={1}
                step={1}
                required={true}
                value={sliderInfo.sequence}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Image <span className='text-danger'>*</span>
              </Label>
              <Input
                id='productImg'
                type='file'
                className='me-1'
                name='productImg'
                accept='image/png, image/jpeg, image/jpg'
                required={true}
                key={mykey || ''}
                ref={fileInputRef} 
                onChange={addImage}
              />
            </div>
            {productImg   ?  <div className='mb-3 mt-3'>
             
              <div>
              <img
                 style={{width: 180}}
                 src={fileInputRef.current.value || ''} />
              </div>
            </div> :null}
           
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleSaveClick}
                >
                  Save
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>         
              </Col>

             
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    
      <Row sm="12" className="mt-4 text-center">
          <Link to={"/sliders/view"} className="go_back" >
            <BiLeftArrowAlt size={30} />  Go to Slider List
          </Link>
      </Row> 
    </div>
  );
};

export default AddSlider;
